var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-col"},[_c('v-card',{attrs:{"max-width":"460px"}},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Brukervilkår")]),_vm._v(" "),_c('v-card-text',[_c('at-userterms')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }